import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../themes/common";
import { theme } from "../theme/lexusTheme";

export const Step = styled.span<{ isActive?: boolean; noPadding?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    font-family: ${theme.fonts.book};
    font-size: 1.4rem;
    line-height: 2rem;
    text-align: center;
    text-transform: uppercase;
    color: ${theme.colors.platinumMedium};

    @media ${getBreakpoint("up", "lg")} {
        align-items: center;
        text-align: start;
        color: ${theme.colors.mist};
        &::before {
            display: inline-block;
            width: 21px;
            height: 1.5px;
            margin: 0 20px;
            content: "";
            background-color: ${theme.colors.brushedSteel};
        }
    }

    ${({ isActive }) =>
        isActive &&
        css`
            color: ${theme.colors.white};
        `};
`;

export const StepInner = styled.span<{ isActive?: boolean }>`
    display: block;
    width: 100%;
    padding: 2px ${theme.space[1]}px;
    text-align: center;
    color: ${theme.colors.mist};
    @media ${getBreakpoint("up", "lg")} {
        display: inline;
        padding: 4px;
        border-radius: 20px;
    }
    ${({ isActive }) =>
        isActive &&
        css`
            color: ${theme.colors.platinumMedium};
            @media ${getBreakpoint("up", "lg")} {
                color: ${theme.colors.midnight};
                background: ${theme.colors.white};
            }
        `};
`;

export const StepWithoutLink = styled.div`
    cursor: default;
    @media ${getBreakpoint("up", "lg")} {
        padding-left: 45px;
    }

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "lg")} {
            padding-left: 0;
            padding-right: 45px;
        }
    }
`;

export const Icon = styled.span<{ isActive?: boolean }>`
    display: none;
    @media ${getBreakpoint("up", "lg")} {
        display: inline-block;
        margin-left: ${theme.space[1]}px;
    }
    ${({ isActive }) =>
        isActive &&
        css`
            color: ${theme.colors.midnight};
        `};

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "lg")} {
            margin-left: ${theme.space[1]}px;
            margin-right: 0;
        }
    }
`;

export const Wrapper = styled.div`
    display: flex;

    a {
        text-decoration: none;
    }
`;
